import { missingNativeBuild } from "../nativeError";
var Calendar = Object.freeze({
  getPermissionStatus: function getPermissionStatus() {
    return "denied";
  },
  requestPermission: function requestPermission() {
    return Promise.resolve("denied");
  },
  list: function list(_startMs, _endMs) {
    var _limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    return Promise.resolve([]);
  },
  create: function create(_input) {
    return Promise.reject(missingNativeBuild("Calendar.create"));
  },
  update: function update(_identifier, _originalStartMs, _changes) {
    return Promise.reject(missingNativeBuild("Calendar.update"));
  },
  delete: function _delete(_identifier, _startMs) {
    return Promise.resolve();
  },
  getRemindersPermissionStatus: function getRemindersPermissionStatus() {
    return "denied";
  },
  requestRemindersPermission: function requestRemindersPermission() {
    return Promise.resolve("denied");
  },
  listReminders: function listReminders() {
    var _limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100, _includeCompleted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Promise.resolve([]);
  },
  createReminder: function createReminder(_input) {
    return Promise.reject(missingNativeBuild("Calendar.createReminder"));
  },
  setReminderCompleted: function setReminderCompleted(_identifier, _completed) {
    return Promise.resolve();
  },
  deleteReminder: function deleteReminder(_identifier) {
    return Promise.resolve();
  }
});
export {
  Calendar
};
//# sourceMappingURL=unavailable.js.map
